import axios from 'axios';
// import mockResults from '../../_patterns/01-components/Press-center-news-events/article-listing-mock-response.html'; <!-- Ex of using importing raw html -->

let VCA = VCA || {};

VCA.PressArticleListing = (function ($) {
    let numberOfItemsToShow = $('#ArticleListingNumberOfItemsToShow').data('number-of-items-to-show');
    let totalPagesOnLoad = $('#ArticleListingTotalPages').data('total-page');


    function setPaginationOnLoad() {

        if ($('#PressArticleListing').length <= 0) {
            return;
        }

        $('#ArticleListingTotalPagesNum').html(totalPagesOnLoad);

        const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
        let page = parseInt(urlParams.get("page"));
        if (window.location.href.match(/\?./) && page) {
            let query = `page=${page}&pageSize=${numberOfItemsToShow}`;
            getAPIData(query, page);
        } else {
            createPagination(totalPagesOnLoad, 1);
        }

        selectPage();
    }

    function selectPage() {
        $('#ArticleListingPagination').on('click', '.pagination-bar__pagination-btn', function (e) {
            e.preventDefault();
            let selectedPage = $(e.currentTarget).data('page');
            let query = `page=${selectedPage}&pageSize=${numberOfItemsToShow}`;
            $('#PressArticleListing')[0].scrollIntoView({ behavior: 'smooth' })
            getAPIData(query, selectedPage);
        });
    }

    function getAPIData(queryStr, selectedPage) {
        let errMsgContainer = $('.vca-voice-current__error-msg-container');
        let errorMessage = $('.vca-voice-current__error-msg');
        let paginationBar = $('.vca-voice-current__pagination-container');
        let aptUrl = $('#PressArticleListing').attr('data-apiurl');  //  /news-api/stories

        createPagination(totalPagesOnLoad, selectedPage);

        $(errMsgContainer).addClass('hidden');

        axios.get(aptUrl + '?' + queryStr)
        .then(response => {
            if (response.data) {
                let parsedData = parseHTML(response.data);
                let totalNumOfPages = $('#ArticleListingTotalPages').data('total-page');
                createPagination(totalNumOfPages,selectedPage);
                $('#PressArticleListing').innerHTML = parsedData;
                $('#ArticleListingTotalPagesNum').html($('#ArticleListingTotalPages').data('total-page'));
            } else {
                $(paginationBar).addClass('hidden');
                $(errorMessage).text('No results were found.')
                $(errMsgContainer).removeClass('hidden');
            }
        })
        .catch(error => {
            console.log('Error message: ', error.response);
        });  
    }

    function createPagination(totalPages, page){
        let liTag = '';
        let active;
        let beforePage = page - 1;
        let afterPage = page + 1;
        let element = document.querySelector("#ArticleListingPagination ul");
        let path = window.location.pathname;

        if (page > 1) {
            liTag += `<li><a href="${path}?page=${page - 1}" class="pagination-bar__pagination-btn prev-btn prev" data-page="${page - 1}"><span>Prev</span></a></li>`;
        } else if (page == 1) {
            liTag += `<li><a href="${path}?page=${page}" class="pagination-bar__pagination-btn prev-btn prev disabled" data-page="${page}"><span>Prev</span></a></li>`;
        }

        if(page > 2){ 
            if (totalPages >= 5) {
                liTag += `<li><a href="${path}?page=1" class="pagination-bar__pagination-btn first numb" data-page="1"><span>1</span></a></li>`;
            }
          if(page > 3 && totalPages > 5){ 
            liTag += `<li class="vca-voice-current__dots dots"><span>...</span></li>`;
          }
        }
        // how many pages or li show before the current li
        if (page == totalPages) {
            beforePage = beforePage - 2;
        } else if (page == totalPages - 1) {
          beforePage = beforePage - 1; 
        }

        if (beforePage < 0) {
            beforePage = 0;
        }
        // how many pages or li show after the current li
        if (page == 1) {
            afterPage = afterPage + 2;
        } else if (page == 2) {
            afterPage = afterPage + 1;
        }
        for (let plength = beforePage; plength <= afterPage; plength++) {
            if (plength > totalPages) { //if plength is greater than totalPage length then continue
                continue;
            }
            if (plength == 0) { //if plength is 0 than add +1 in plength value
                plength = plength + 1;
            }
            if (page == plength) { //if page is equal to plength than assign active string in the active variable
                active = "active";
            } else { //else leave empty to the active variable
                active = "";
            }
            liTag += `<li><a href="${path}?page=${plength}" class="pagination-bar__pagination-btn numb ${active}"data-page="${plength}"><span>${plength}</span></a></li>`;
        }

        if (page < totalPages - 1) { //if page value is less than totalPage value by -1 then show the last li or page 
          if (page < totalPages - 2 && totalPages > 5) { //if page value is less than totalPage value by -2 then add this (...) before the last li or page 
            liTag += `<li class="vca-voice-current__dots dots"><span>...</span></li>`;
          }
          if (totalPages >= 5) {
            liTag += `<li><a href="${path}?page=${totalPages}" class="pagination-bar__pagination-btn last numb" data-page="${totalPages}"><span>${totalPages}</span></a></li>`;
          }
        }

        if (page <= totalPages) { //show the next button if the page value is less than totalPage 
            if (page < totalPages) { 
                liTag += `<li><a href="${path}?page=${page + 1}" class="pagination-bar__pagination-btn next-btn next" data-page="${page + 1}"><span>Next</span></a></li>`;
            } else if (page == totalPages) { 
                liTag += `<li><a href="${path}?page=${page}" class="pagination-bar__pagination-btn next-btn next disabled" data-page="${page}"><span>Next</span></a></li>`;
            }
        }
        element.innerHTML = liTag; //add li tag inside ul tag
        $('#ArticleListingCurrentPageNum').text(page);


        return liTag; 
    }
 
    function parseHTML(html) {
        let resultsContainer = $('#PressArticleListing')[0];
        resultsContainer.innerHTML = html;
    
        return resultsContainer.childNodes;
    }

    function init() {
        setPaginationOnLoad();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.PressArticleListing.init();
});

